import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import Wrapper from "./Wrapper";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<Wrapper />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
